mutation UpdateGrantCaseRecord($input: UpdateGrantCaseRecordInput!) {
  updateGrantCaseRecord(input: $input) {
    grantCaseRecord {
      readyForRelease
      grantRiskLevel {
        tier
        reasons
      }
    }
  }
}
